<template>
    <div class="tl-row">
        <div class="tl-columnheader">
            <h2 class="tl-tit">연락처 <span class="color-red">*</span></h2>
        </div>
        <div class="tl-cell">
            <div class="form-tel">
                <select v-model="phone1" class="select" @input="setInput">
                    <option value="010">010</option>
                </select>
                <span class="text"></span>
                <input v-model="phone2" type="number" class="input" @input="setInput" />
                <span class="text"></span>
                <input v-model="phone3" type="number" class="input" @input="setInput" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            phone1: "010",
            phone2: "",
            phone3: "",
        };
    },
    mounted() {
        this.setInput();
    },
    methods: {
        setInput(event) {
            this.$emit("set-input", { phone: this.phone });
        },
    },
    computed: {
        phone() {
            return this.phone1 + this.phone2 + this.phone3;
        },
    },
};
</script>
